import {type SvgProps, type NumberProp} from 'react-native-svg';
import {getDescriber} from '../../../screens/descriptor/DescriptorType';
export function EliteBuyerTierIcon({
  size,
  ...props
}: SvgProps & {size?: NumberProp}) {
  return getDescriber()?.getEliteBuyerTier(size, props);
}
